import { render, staticRenderFns } from "./ShopAssetCategory.vue?vue&type=template&id=7c858716&scoped=true&"
import script from "./ShopAssetCategory.vue?vue&type=script&lang=js&"
export * from "./ShopAssetCategory.vue?vue&type=script&lang=js&"
import style0 from "./ShopAssetCategory.vue?vue&type=style&index=0&id=7c858716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c858716",
  null
  
)

export default component.exports